import { render, staticRenderFns } from "./InfosMedia.vue?vue&type=template&id=550f865d&scoped=true"
import script from "./InfosMedia.vue?vue&type=script&lang=js"
export * from "./InfosMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f865d",
  null
  
)

export default component.exports